module.exports = __webpack_public_path__ + "img/pk.13c3b38a.svg";